import { createSlice } from "@reduxjs/toolkit";
import { AuthInitialState } from "../../types";

const initialState: AuthInitialState = {
  access_token: undefined,
  isAuthenticated: false,
  user: null,
  role: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    userLoggedIn: (state, action) => {
      state.access_token = action.payload;
      state.isAuthenticated = true;
    },
    userLoggedOut: (state) => {
      state.access_token = undefined;
      state.isAuthenticated = false;
    },
    setUserInfo: (state, action) => {
      state.user = action.payload;
      state.role = action.payload?.data?.permission;
    },

    setSuccessSignup: (state, action) => {
      state.isSuccessSignup = action.payload;
    },
    setRole: (state, action) => {
      state.role = action.payload;
    },
  },
});

export const {
  userLoggedIn,
  userLoggedOut,
  setSuccessSignup,
  setUserInfo,
  setRole,
} = authSlice.actions;
export default authSlice.reducer;
